<template>
  <reg-card>
    <div class="card-icon">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="#ff825d"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>
    </div>
    <h2 class="title">Resumo</h2>

    <div class="linha">
      <span>Plano</span>
      <span>{{ resumo.plano }}</span>
    </div>
    <div class="linha">
      <span>Add-on cartões</span>
      <span>{{ resumo.addon_cartoes || '—' }}</span>
    </div>
    <div class="linha">
      <span>Add-on notificações</span>
      <span>{{ resumo.addon_notificacoes || '—' }}</span>
    </div>
    <div class="linha">
      <span>Avença</span>
      <span>{{ resumo.avenca ? 'Sim' : 'Não' }}</span>
    </div>

    <div class="total">
      <span>Total</span>
      <span class="total-val">{{ precoTotal }}€/mês</span>
    </div>

    <div class="oferta">
      <strong>Oferta:</strong> 1 comunicação por mês, definida e processada pela Abitué
    </div>

    <button class="btn-dark" :disabled="loading" @click="$emit('done')">
      <span v-if="loading" class="spinner"></span>
      <span v-else>SUBSCREVER</span>
    </button>
  </reg-card>
</template>

<script>
import RegCard from "../components/RegCard.vue";
export default {
  name: "OStep5",
  components: { RegCard },
  props: {
    resumo:     { type: Object,  required: true },
    precoTotal: { type: Number,  default: 0 },
    loading:    { type: Boolean, default: false },
  },
};
</script>

<style scoped lang="scss">
.card-icon  { width: 36px; height: 36px; background: #fff5f0; border-radius: 10px; display: flex; align-items: center; justify-content: center; margin-bottom: 12px; }
.title      { font-size: 22px; font-weight: 800; color: #1a1210; margin-bottom: 16px; }
.linha      { display: flex; justify-content: space-between; padding: 12px 0; border-bottom: 1px solid #f5f2ef; font-size: 14px; font-weight: 600; color: #3a3430; span:last-child { color: #7a736e; } }
.total      { display: flex; justify-content: space-between; padding: 16px 0 8px; font-size: 16px; font-weight: 700; color: #1a1210; }
.total-val  { color: #ff825d; font-size: 20px; font-weight: 800; }
.oferta     { background: #fff7f5; border-radius: 8px; padding: 12px 14px; font-size: 13px; color: #7a736e; margin-bottom: 4px; }
.btn-dark   { display: flex; align-items: center; justify-content: center; gap: 8px; width: 100%; height: 50px; border: none; border-radius: 10px; background: #1a1210; color: #fff; font-size: 14px; font-weight: 700; cursor: pointer; font-family: inherit; margin-top: 16px; &:hover:not(:disabled) { background: #2d2420; } &:disabled { opacity: .55; cursor: default; } }
.spinner    { width: 18px; height: 18px; border: 2px solid rgba(255,255,255,.4); border-top-color: #fff; border-radius: 50%; animation: spin .6s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }
</style>
